<div class="app-container redesign-shell">
  <app-announcement-bar></app-announcement-bar>
  <app-top-nav></app-top-nav>
  <app-mobile-drawer></app-mobile-drawer>

  <router-outlet (activate)="onActivate($event)"></router-outlet>

  <ng-container *ngIf="isMobile == false && hitFooter==false && showCartIcon===true">
    <app-cart-icon class="normal"></app-cart-icon>
  </ng-container>
  <ng-container *ngIf="isMobile == false && hitFooter==true && showCartIcon===true">
    <app-cart-icon class="follow"></app-cart-icon>
  </ng-container>
  <ng-container *ngIf="isMobile == true && hitFooterMobile==false && showCartIcon===true">
    <app-cart-icon class="normal-mobile"></app-cart-icon>
  </ng-container>
  <ng-container *ngIf="isMobile == true && hitFooterMobile==true && showCartIcon===true">
    <app-cart-icon class="follow-mobile"></app-cart-icon>
  </ng-container>

  <app-site-footer></app-site-footer>
  <app-loading-page></app-loading-page>
  <app-product-popup></app-product-popup>
</div>
